import { css } from 'styled-components';

export interface WithCursorProps {
  cursor?: string;
  pointerEvents?: string;
}

export const withCursorCSS = ({
  cursor,
  pointerEvents,
}: WithCursorProps) => css`
  ${cursor && `cursor: ${cursor};`}
  ${pointerEvents && `pointer-events: ${pointerEvents};`}
`;
